<script>
  // Internal viewer shared by clickable_image/clickable_video. `items`: [{ type: 'image'|'video', url, title? }]
  // `actions(close)` is an optional snippet of extra controls (e.g. "Change picture");
  // it receives a close callback so an action can dismiss the viewer before opening
  // a modal of its own.
  import { page } from '@inertiajs/svelte'
  import Button from '../ui/button.svelte'

  let { open = $bindable(false), items = [], index = $bindable(0), actions } = $props()

  const close = () => (open = false)

  const current = $derived(items[index])

  const prev = () => {
    index = (index - 1 + items.length) % items.length
  }

  const next = () => {
    index = (index + 1) % items.length
  }

  // A plain GET: the server redirects to a signed "attachment" URL, so the file saves
  // instead of opening a tab (AdminSite::MediaDownloadsController).
  const downloadHref = $derived(
    current && $page.props.media_download_path
      ? `${$page.props.media_download_path}?${new URLSearchParams({ url: current.url, filename: current.title ?? '' })}`
      : null
  )

  // Every clickable row mounts its own viewer, so only the open one reacts to keys.
  const onkeydown = (event) => {
    if (!open) return
    if (event.key === 'ArrowLeft') prev()
    if (event.key === 'ArrowRight') next()
    if (event.key === 'Escape') open = false
  }
</script>

<svelte:window {onkeydown} />

<dialog class="modal" class:modal-open={open}>
  <div class="modal-box max-w-4xl">
    <Button variant="ghost" size="sm" circle icon="close" class="absolute right-2 top-2" aria-label="Close" onclick={() => (open = false)} />

    <!-- Media mounts only while open: closing unmounts a playing video, and closed rows load nothing. -->
    {#if open && current}
      <div class="flex items-center justify-center bg-base-300 rounded-box min-h-[50vh]">
        {#if current.type === 'video'}
          <video src={current.url} controls class="max-h-[70vh] max-w-full"></video>
        {:else}
          <img src={current.url} alt={current.title || ''} class="max-h-[70vh] max-w-full object-contain" />
        {/if}
      </div>

      <div class="modal-action justify-between items-center">
        <div class="join">
          <Button variant="default" size="sm" class="join-item" icon="chevron_left" onclick={prev} disabled={items.length < 2}>Prev</Button>
          <Button variant="default" size="sm" class="join-item" iconEnd="chevron_right" onclick={next} disabled={items.length < 2}>Next</Button>
        </div>
        <div class="flex items-center gap-2">
          {@render actions?.(close)}
          {#if downloadHref}<Button variant="primary" size="sm" icon="download" href={downloadHref} external>Download</Button>{/if}
        </div>
      </div>
    {/if}
  </div>

  <button type="button" class="modal-backdrop" aria-label="Close" onclick={() => (open = false)}></button>
</dialog>
